import { defineMessages } from 'react-intl';

const messages = defineMessages({
  Overview: {
    id: 'Overview',
    defaultMessage: 'Overview',
  },
  FutureProspects: {
    id: 'Future Prospects',
    defaultMessage: 'Why study this?',
  },
  StructureAndContents: {
    id: 'Structure and contents',
    defaultMessage: 'Structure and programme contents',
  },
  International: {
    id: 'International',
    defaultMessage: 'International',
  },
  RequirementsAndAdmission: {
    id: 'Requirements and admission',
    defaultMessage: 'Requirements and admission',
  },
  OrganisationalMatters: {
    id: 'Organisational matters',
    defaultMessage: 'Organisational matters',
  },
  ConsultingAndInfoEvents: {
    id: 'Advising and information events',
    defaultMessage: 'Advising and information events',
  },
  InfoEvents: {
    id: 'Information events',
    defaultMessage: 'Information events',
  },
  ObjectivesAndBenefits: {
    id: 'Aims and benefits',
    defaultMessage: 'Aims and benefits',
  },
  TargetAudience: {
    id: 'Target audience',
    defaultMessage: 'Target audience',
  },
  StructureOfContinuingEducation: {
    id: 'Structure of continuing education',
    defaultMessage: 'Structure of continuing education',
  },
  Registration: {
    id: 'Registration',
    defaultMessage: 'Registration',
  },
  Lecturers: {
    id: 'Lecturers',
    defaultMessage: 'Lecturers',
  },
  Attend: {
    id: 'Attend',
    defaultMessage: 'Attend',
  },
  Activities: {
    id: 'Activities',
    defaultMessage: 'Activities',
  },
  Expertise: {
    id: 'Expertise',
    defaultMessage: 'Expertise',
  },
  ProfessionalCareer: {
    id: 'Professional career',
    defaultMessage: 'Professional career',
  },
  TeachingActivity: {
    id: 'Teaching activity',
    defaultMessage: 'Teaching activity',
  },
  SelectedProjects: {
    id: 'Selected projects',
    defaultMessage: 'Selected projects',
  },
  InstitutionalRepository: {
    id: 'Institutional repository',
    defaultMessage: 'Institutional repository',
  },
  Publications: {
    id: 'Publications, projects and presentations',
    defaultMessage: 'Publications, projects and presentations',
  },
  Programme: {
    id: 'Programme',
    defaultMessage: 'Programme',
  },
  Projects: {
    id: 'Projects',
    defaultMessage: 'Projects',
  },
  Services: {
    id: 'Services',
    defaultMessage: 'Services',
  },
  DegreeProgrammesOfferings: {
    id: 'Degree programmes offerings',
    defaultMessage: 'Degree programmes offerings',
  },
  ContinuingEducationOfferings: {
    id: 'Continuing education offerings',
    defaultMessage: 'Continuing education offerings',
  },
  Events: {
    id: 'Events',
    defaultMessage: 'Events',
  },
  Testimonial: {
    id: 'Testimonial',
    defaultMessage: 'Testimonial',
  },
  FurtherProjects: {
    id: 'Further projects',
    defaultMessage: 'Further projects',
  },
});

export const initialBlocks = {
  Document: [
    {
      '@type': 'slate',
      plaintext: '',
      value: [{ children: [{ text: '' }], type: 'p' }],
    },
  ],
  Project: [
    {
      '@type': 'group',
      block_nav_title: messages.Overview,
    },
    {
      '@type': 'group',
      block_title: messages.Testimonial,
      block_divider: {
        show: true,
      },
    },
    {
      '@type': 'keydata',
      required: true,
      block_divider: {
        show: true,
      },
    },
    {
      '@type': 'contacts',
      block_divider: {
        show: true,
      },
    },
    {
      '@type': 'group',
      block_title: messages.FurtherProjects,
      block_divider: {
        show: true,
      },
    },
  ],
  InfoEvent: [
    {
      '@type': 'keydata',
      required: true,
    },
    {
      '@type': 'group',
      block_title: messages.Programme,
      block_divider: {
        show: true,
      },
    },
    {
      '@type': 'contacts',
      block_divider: {
        show: true,
      },
    },
    {
      '@type': 'group',
      block_title: messages.Attend,
      block_divider: {
        show: true,
      },
      data: {
        blocks: {
          application: {
            '@type': 'application',
            block_followup: true,
            block_compact: true,
          },
        },
        blocks_layout: {
          items: ['application'],
        },
      },
    },
  ],
  FHNWEvent: [
    {
      '@type': 'keydata',
      required: true,
    },
    {
      '@type': 'group',
      block_title: messages.Programme,
      block_divider: {
        show: true,
      },
    },
    {
      '@type': 'contacts',
      block_divider: {
        show: true,
      },
    },
    {
      '@type': 'group',
      block_title: messages.Attend,
      block_divider: {
        show: true,
      },
      data: {
        blocks: {
          application: {
            '@type': 'application',
            block_followup: true,
            block_compact: true,
          },
        },
        blocks_layout: {
          items: ['application'],
        },
      },
    },
  ],
  ConEduEvent: [
    {
      '@type': 'slate',
      plaintext: '',
      value: [{ children: [{ text: '' }], type: 'p' }],
    },
  ],
  DegreeProgram: [
    {
      '@type': 'group',
      title: messages.Overview,
      block_nav_title: messages.Overview,
    },
    {
      '@type': 'keydata',
      required: true,
      block_divider: {
        show: true,
      },
    },
    {
      '@type': 'group',
      title: messages.FutureProspects,
      block_title: messages.FutureProspects,
      block_divider: {
        show: true,
      },
    },
    {
      '@type': 'group',
      title: messages.StructureAndContents,
      block_title: messages.StructureAndContents,
      block_divider: {
        show: true,
      },
      block_compact: true,
    },
    {
      '@type': 'group',
      title: messages.International,
      block_title: messages.International,
      block_divider: {
        show: true,
      },
    },
    {
      '@type': 'group',
      title: messages.Lecturers,
      block_title: messages.Lecturers,
      block_divider: {
        show: true,
      },
      data: {
        blocks: {
          lecturers: {
            '@type': 'lecturers',
            block_followup: true,
            block_compact: true,
          },
        },
        blocks_layout: {
          items: ['lecturers'],
        },
      },
    },
    {
      '@type': 'group',
      title: messages.RequirementsAndAdmission,
      block_title: messages.RequirementsAndAdmission,
      block_divider: {
        show: true,
      },
    },
    {
      '@type': 'group',
      title: messages.OrganisationalMatters,
      block_title: messages.OrganisationalMatters,
      block_divider: {
        show: true,
      },
    },
    {
      '@type': 'group',
      title: messages.ConsultingAndInfoEvents,
      block_title: messages.ConsultingAndInfoEvents,
      block_divider: {
        show: true,
      },
      data: {
        blocks: {
          contacts: {
            '@type': 'contacts',
            block_followup: true,
            block_compact: true,
          },
          infoevent: {
            '@type': 'infoevent',
            block_title: messages.InfoEvents,
            block_followup: true,
            block_compact: true,
          },
        },
        blocks_layout: {
          items: ['contacts', 'infoevent'],
        },
      },
    },
    {
      '@type': 'group',
      title: messages.Registration,
      block_title: messages.Registration,
      block_divider: {
        show: true,
      },
      data: {
        blocks: {
          application: {
            '@type': 'application',
            block_followup: true,
            block_compact: true,
          },
        },
        blocks_layout: {
          items: ['application'],
        },
      },
    },
  ],
  ContinuingEducation: [
    {
      '@type': 'group',
      title: messages.Overview,
      block_nav_title: messages.Overview,
    },
    {
      '@type': 'keydata',
      required: true,
      block_divider: {
        show: true,
      },
    },
    {
      '@type': 'group',
      title: messages.ObjectivesAndBenefits,
      block_title: messages.ObjectivesAndBenefits,
      block_divider: {
        show: true,
      },
    },
    {
      '@type': 'group',
      title: messages.TargetAudience,
      block_title: messages.TargetAudience,
      block_divider: {
        show: true,
      },
      block_compact: true,
    },
    {
      '@type': 'group',
      title: messages.StructureAndContents,
      block_title: messages.StructureAndContents,
      block_divider: {
        show: true,
      },
      block_compact: true,
    },
    {
      '@type': 'group',
      title: messages.International,
      block_title: messages.International,
      block_divider: {
        show: true,
      },
    },
    {
      '@type': 'group',
      title: messages.Lecturers,
      block_title: messages.Lecturers,
      block_divider: {
        show: true,
      },
      data: {
        blocks: {
          lecturers: {
            '@type': 'lecturers',
            block_followup: true,
            block_compact: true,
          },
        },
        blocks_layout: {
          items: ['lecturers'],
        },
      },
    },
    {
      '@type': 'group',
      title: messages.RequirementsAndAdmission,
      block_title: messages.RequirementsAndAdmission,
    },
    {
      '@type': 'group',
      title: messages.OrganisationalMatters,
      block_title: messages.OrganisationalMatters,
    },
    {
      '@type': 'group',
      title: messages.ConsultingAndInfoEvents,
      block_title: messages.ConsultingAndInfoEvents,
      block_divider: {
        show: true,
      },
      data: {
        blocks: {
          contacts: {
            '@type': 'contacts',
            block_followup: true,
            block_compact: true,
          },
          infoevent: {
            '@type': 'infoevent',
            block_title: messages.InfoEvents,
            block_followup: true,
            block_compact: true,
          },
        },
        blocks_layout: {
          items: ['contacts', 'infoevent'],
        },
      },
    },
    {
      '@type': 'group',
      title: messages.Registration,
      block_title: messages.Registration,
      block_divider: {
        show: true,
      },
      data: {
        blocks: {
          application: {
            '@type': 'application',
            block_followup: true,
            block_compact: true,
          },
        },
        blocks_layout: {
          items: ['application'],
        },
      },
    },
  ],
  FHNWNews: [
    {
      '@type': 'slate',
      plaintext: '',
      value: [{ children: [{ text: '' }], type: 'p' }],
    },
    {
      '@type': 'contacts',
      block_divider: {
        show: true,
      },
    },
  ],
  Contact: [
    {
      '@type': 'group',
      block_title: messages.Activities,
      block_divider: {
        show: true,
      },
    },
    {
      '@type': 'group',
      block_title: messages.Expertise,
      block_divider: {
        show: true,
      },
    },
    {
      '@type': 'group',
      block_title: messages.ProfessionalCareer,
      block_divider: {
        show: true,
      },
    },
    {
      '@type': 'group',
      block_title: messages.TeachingActivity,
      block_divider: {
        show: true,
      },
    },
    {
      '@type': 'group',
      block_title: messages.SelectedProjects,
      block_divider: {
        show: true,
      },
    },
    {
      '@type': 'group',
      block_title: messages.Publications,
      block_divider: {
        show: true,
        title: messages.InstitutionalRepository,
      },
    },
  ],
  TeamContact: [
    {
      '@type': 'slate',
      plaintext: '',
      value: [{ children: [{ text: '' }], type: 'p' }],
    },
  ],
  Specialization: [
    {
      '@type': 'slate',
      plaintext: '',
      value: [{ children: [{ text: '' }], type: 'p' }],
    },
  ],
  Topic: [
    {
      '@type': 'slate',
      plaintext: '',
      value: [{ children: [{ text: '' }], type: 'p' }],
    },
  ],
  ResearchArea: [
    {
      '@type': 'group',
      block_nav_title: messages.Overview,
    },
    {
      '@type': 'research_focus',
      block_compact: true,
      block_divider: {
        show: true,
      },
    },
    {
      '@type': 'group',
      block_title: messages.SelectedProjects,
      block_divider: {
        show: true,
        title: messages.Projects,
      },
    },
    {
      '@type': 'group',
      block_title: messages.Publications,
      block_divider: {
        show: true,
        title: messages.InstitutionalRepository,
      },
    },
    {
      '@type': 'group',
      block_title: messages.Services,
      block_divider: {
        show: true,
      },
    },
    {
      '@type': 'group',
      block_title: messages.DegreeProgrammesOfferings,
      block_divider: {
        show: true,
      },
    },
    {
      '@type': 'group',
      block_title: messages.ContinuingEducationOfferings,
      block_divider: {
        show: true,
      },
    },
    {
      '@type': 'contacts',
      block_divider: {
        show: true,
      },
    },
    {
      '@type': 'group',
      block_title: messages.Events,
      block_divider: {
        show: true,
      },
    },
  ],
  ResearchFocus: [
    {
      '@type': 'slate',
      plaintext: '',
      value: [{ children: [{ text: '' }], type: 'p' }],
    },
  ],
  University: [
    {
      '@type': 'slate',
      plaintext: '',
      value: [{ children: [{ text: '' }], type: 'p' }],
    },
  ],
  LRF: [
    {
      '@type': 'slate',
      plaintext: '',
      value: [{ children: [{ text: '' }], type: 'p' }],
    },
  ],
  Location: [
    {
      '@type': 'slate',
      plaintext: '',
      value: [{ children: [{ text: '' }], type: 'p' }],
    },
  ],
};
